import moment from 'moment';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

function jsonToHTML(params) {
  let data = params.printable;
  let properties = params.properties;
  let htmlData =
    '<table style=" width: 100%; text-align: center;" border="1" cellspacing="0" cellpadding="0">';

  htmlData += '<tr>';
  for (let a = 0; a < properties.length; a++) {
    if (properties[a].show) {
      htmlData +=
        '<th style="width:auto; text-align: center;' +
        params.gridHeaderStyle +
        '">' +
        properties[a].Header +
        '</th>';
    }
  }
  htmlData += '</tr>';

  for (let i = 0; i < data.length; i++) {
    htmlData += '<tr>';
    for (let n = 0; n < properties.length; n++) {
      if (properties[n].show) {
        let stringData = data[i][properties[n].accessor]
          ? data[i][properties[n].accessor]
          : '';
        htmlData +=
          '<td style="width:auto;' +
          params.gridStyle +
          '">' +
          stringData +
          '</td>';
      }
    }
    htmlData += '</tr>';
  }

  htmlData += '</table>';
  return htmlData;
}
function printOrderDetails(params) {
  let orderData = params.printable;
  let htmlData = '';
  for (let i = 0; i < orderData.length; i++) {
    let order = orderData[i];
    if (i) {
      htmlData +=
        '<h1 style="' + params.headerStyle + '">' + params.header + '</h1>';
    }
    htmlData +=
      "<div style='display:table;width:100%;'>" +
      "<div style='display:table-cell;width:20%'>Order#:" +
      order.Id +
      '</div>' +
      "<div style='display:table-cell;width:20%'>Status:" +
      order.Status +
      '</div>' +
      "<div style='display:table-cell;width:20%'>Site:" +
      order.SiteId +
      ' ' +
      order.SiteName +
      '</div>' +
      "<div style='display:table-cell;width:20%'>Order Date:" +
      moment(order.OrderDate).format(DATE_FORMAT_FOR_UI) +
      '</div>' +
      "<div style='display:table-cell;width:20%'>Delivery Date:" +
      moment(order.DeliveryDate).format(DATE_FORMAT_FOR_UI) +
      '</div>' +
      '</div><br><br>' +
      "<table style=' width: 100%; text-align: center;page-break-after: always;' border='1' cellspacing='0' cellpadding='0'>" +
      '<thead><tr>' +
      '<th rowspan="2">Item Code</th>' +
      '<th rowspan="2">Description</th>' +
      '<th rowspan="2">Unit/Package</th>' +
      '<th rowspan="2">Vendor</th>' +
      '<th rowspan="2">Price</th>' +
      '<th colspan="2">Quantity Order</th>' +
      '<th rowspan="2">Cost</th>' +
      '</tr>' +
      '</tr>' +
      '<th>Purchasing Qty</th>' +
      '<th>Pack Qty</th>' +
      '<tr>';
    let total = 0;
    for (let index = 0; index < order.ItemList.length; index++) {
      let item = order.ItemList[index];
      total += Number(item.Cost);
      htmlData +=
        '<tr><td>' +
        item.ItemCode +
        '</td><td>' +
        item.Description +
        '</td><td>' +
        item.ItemPackaging +
        '</td><td>' +
        item.VendorName +
        '</td><td>' +
        item.PrimaryPrice +
        '</td><td>' +
        (item.PriQty ? item.PriQty : '0') +
        '</td><td>' +
        (item.SecQty ? item.SecQty : '0') +
        '</td><td>' +
        item.Cost.toFixed(2) +
        '</td></tr>';
    }
    htmlData +=
      '</tbody>' +
      '<tfoot>' +
      "<tr colspan='3'>" +
      "<td colspan='4' scope='colgroup'></td>" +
      "<td colspan='3' scope='colgroup'>Total Merchandise Amount:</td>" +
      "<td colspan='1' scope='colgroup'>" +
      total.toFixed(2) +
      '</td>' +
      '</tr>' +
      '</tfoot>' +
      '</table>';
  }
  return htmlData;
}
export const printGrid = params => {
  params.properties = params.properties.map(property => {
    return {
      accessor: typeof property === 'object' ? property.accessor : property,
      Header: typeof property === 'object' ? property.Header : property,
      columnSize:
        typeof property === 'object' && property.columnSize
          ? property.columnSize + ';'
          : 100 / params.properties.length + '%;',
      show: typeof property === 'object' ? property.show : property,
    };
  });

  let htmlData =
    params.type === 'order'
      ? '<html><head><style type="text/css" media="print">@page { size: landscape; }</style></head><body>'
      : '<html><body>';
  if (params.header)
    htmlData +=
      '<h1 style="' + params.headerStyle + '">' + params.header + '</h1>';
  htmlData +=
    params.type === 'order' ? printOrderDetails(params) : jsonToHTML(params);
  htmlData += '</body></html>';

  const printWin = window.open(
    '',
    '',
    'left=0,top=0,toolbar=no,scrollbars=0,resizable=yes,titlebar=0,height=640,width=1050'
  );
  printWin.document.write(htmlData);
  printWin.document.close();
  printWin.focus();
  printWin.onload = function() {
    printWin.moveTo(0, 0);
    printWin.resizeTo(1050, 1050);
    printWin.print();
    setTimeout(function() {
      printWin.close();
    }, 500);
  };
};



// WEBPACK FOOTER //
// ./src/common/PrintGrid.js